export const getQuantityOptions = t =>
  Array.from({ length: 50 }, (_, i) => ({
    value: i + 1,
    label: t('quantity_packs', { count: i + 1 }),
  }));
